import { FeatureWrapper, Feature } from "./ProductFeatures.styles"
import { useTranslation } from "hooks/useTranslation"
import { Proteins } from "models/Pet"

type ProductFeaturesProps = {
    recipe: Proteins
}

export const ProductFeatures = ({recipe}: ProductFeaturesProps) => {
    const { t } = useTranslation()
    return (
        <>
        <FeatureWrapper>
            <Feature size="body">{t(`recipes:${recipe}.hero.feat-1`)}</Feature>
            <Feature size="body">{t(`recipes:${recipe}.hero.feat-2`)}</Feature>
            <Feature size="body">{t(`recipes:${recipe}.hero.feat-3`)}</Feature>
            <Feature size="body">{t(`recipes:${recipe}.hero.feat-4`)}</Feature>
        </FeatureWrapper>
        </>
    )
}